@if (comment) {
  @if (comment.author_id) {
    <app-show-user-entity-logo [entity]="comment?.author?.entity" [fontSize]="fontSize"/>
  } @else {
    <app-single-letter-icon [text]="'?'" [title]="''"/>
  }
}
